import { Avatar, AvatarGroup, Box, Stack, Typography } from "@mui/material";
import type { ChannelPreviewUIComponentProps } from "stream-chat-react";
import { useChatContext } from "stream-chat-react";
import { useChatChannelDisplayInfo } from "Hooks/Chat/useChatChannelDisplayInfo";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Chat.Requests;

export const ChatRequestPreview = (props: ChannelPreviewUIComponentProps) => {
  const { channel, lastMessage, setActiveChannel } = props;
  const { client } = useChatContext();
  const { t } = useResource();

  const { displayName, avatarImage, isGroup, otherMembers } =
    useChatChannelDisplayInfo(channel, client.userID);

  const previewText =
    lastMessage?.text ?? t(RESOURCES.RequestMessage, { name: displayName });

  return (
    <Box
      px={2}
      py={1.5}
      borderBottom="1px solid"
      borderColor="divider"
      sx={{ cursor: "pointer" }}
      onClick={() => setActiveChannel?.(channel)}
    >
      <Stack direction="row" alignItems="center" gap={1.5}>
        {isGroup ? (
          <AvatarGroup
            max={2}
            sx={{
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                fontSize: 14,
              },
            }}
          >
            {otherMembers.map(({ user_id, user }) => (
              <Avatar
                key={user_id}
                src={user?.image}
                alt={user?.name ?? user_id}
              />
            ))}
          </AvatarGroup>
        ) : (
          <Avatar
            src={avatarImage}
            alt={displayName}
            sx={{ width: 40, height: 40 }}
          />
        )}
        <Box flex={1} minWidth={0}>
          <Typography fontWeight={600} fontSize={14} noWrap>
            {displayName}
          </Typography>
          <Typography fontSize={13} color="text.secondary" noWrap>
            {previewText}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};
